{
  "LOGIN": {
    "TITLE": "Se connecter à Chatwoot",
    "EMAIL": {
      "LABEL": "Courriel",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Veuillez saisir une adresse de courriel valide"
    },
    "PASSWORD": {
      "LABEL": "Mot de passe",
      "PLACEHOLDER": "Mot de passe"
    },
    "API": {
      "SUCCESS_MESSAGE": "Connexion réussie",
      "ERROR_MESSAGE": "Impossible de se connecter au serveur Woot, veuillez réessayer plus tard",
      "UNAUTH": "Nom d'utilisateur / Mot de passe incorrect. Veuillez réessayer."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Se connecter avec Google",
      "BUSINESS_ACCOUNTS_ONLY": "Veuillez utiliser l'adresse e-mail de votre entreprise pour vous connecter",
      "NO_ACCOUNT_FOUND": "Nous n'avons pas pu trouver de compte pour votre adresse e-mail."
    },
    "FORGOT_PASSWORD": "Mot de passe oublié ?",
    "CREATE_NEW_ACCOUNT": "Créer un nouveau compte",
    "SUBMIT": "Se connecter",
    "SAML": {
      "LABEL": "Login via SSO",
      "TITLE": "Initiate Single Sign-on (SSO)",
      "SUBTITLE": "Enter your work email to access your organization",
      "BACK_TO_LOGIN": "Login via Password",
      "WORK_EMAIL": {
        "LABEL": "Work Email",
        "PLACEHOLDER": "Enter your work email"
      },
      "SUBMIT": "Continue with SSO",
      "API": {
        "ERROR_MESSAGE": "SSO authentication failed. Please check your credentials and try again."
      }
    }
  }
}
